export const capitalizeFirstLetter = (string) => {
  if (!string) return "";
  return string.charAt(0).toUpperCase() + string.slice(1).toLowerCase();
};
export const formatEmptyToNA = (value) =>
  value !== null && value !== undefined && value.trim() !== "" ? value : "N/A";
